function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { createEnum, makeErrorBoundComponent } from '@els/els-react--utils';
import classnames from 'classnames';
import PT from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
var DefaultMessages = createEnum({
  loadingMessage: 'Loading'
});
var bool = PT.bool,
  object = PT.object,
  string = PT.string;
var defaults = {
  className: "",
  id: null,
  isBlocking: true,
  isSmall: false,
  isVisible: false,
  messages: DefaultMessages
};
var Loader = function Loader(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? defaults.className : _ref$className,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? defaults.id : _ref$id,
    _ref$isBlocking = _ref.isBlocking,
    isBlocking = _ref$isBlocking === void 0 ? defaults.isBlocking : _ref$isBlocking,
    _ref$isSmall = _ref.isSmall,
    isSmall = _ref$isSmall === void 0 ? defaults.isSmall : _ref$isSmall,
    _ref$isVisible = _ref.isVisible,
    isVisible = _ref$isVisible === void 0 ? defaults.isVisible : _ref$isVisible,
    _ref$messages = _ref.messages,
    messages = _ref$messages === void 0 ? defaults.messages : _ref$messages;
  var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
  var classes = classnames("c-els-loader", className, {
    "u-els-hide-visually": !isVisible,
    "c-els-loader--page": isBlocking,
    "c-els-loader--small": isSmall
  });
  return /* @__PURE__ */React.createElement("div", {
    className: classes,
    id: id,
    "data-testid": "loader",
    role: "alert",
    "aria-live": "assertive",
    "aria-hidden": !isVisible
  }, isVisible && /* @__PURE__ */React.createElement("div", {
    className: "c-els-loader__wrapper"
  }, /* @__PURE__ */React.createElement("div", {
    className: "c-els-loader__loading-bar"
  }), /* @__PURE__ */React.createElement("div", {
    className: "c-els-loader__loading-bar"
  }), /* @__PURE__ */React.createElement("div", {
    className: "c-els-loader__loading-bar"
  }), /* @__PURE__ */React.createElement("span", {
    className: "u-els-hide-visually"
  }, compiledMessages.LOADING_MESSAGE)));
};
Loader.displayName = "Loader";
Loader.propTypes = {
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string,
  /** A custom ID applied to the component */
  id: string,
  /** The page loader blocks the UI */
  isBlocking: bool,
  /** The loader is small sized */
  isSmall: bool,
  /** The loader is small sized */
  isVisible: bool,
  /** Messages for internationalization */
  messages: object
};
Loader.requiredProps = {};
Loader.defaults = defaults;
Loader.DefaultMessages = DefaultMessages;
var RawLoader = Loader;
var Loader$1 = makeErrorBoundComponent(RawLoader);
export { Loader$1 as Loader, RawLoader };
